import type { LookLikeInference } from '@famecreator/shared-types/look-like';
import { create } from 'zustand';

import { logger } from '@/shared/lib/logger';

type DeleteLookAlikeStore = {
  isOpen: boolean;
  inferenceToDelete: LookLikeInference | null;
  onConfirm: (() => void) | null;
  isLoading: boolean;
  openDeleteModal: (inference: LookLikeInference, onConfirm: () => void) => void;
  closeDeleteModal: () => void;
  confirmDelete: () => void;
  setLoading: (loading: boolean) => void;
};

export const useDeleteLookAlikeStore = create<DeleteLookAlikeStore>((set, get) => ({
  isOpen: false,
  inferenceToDelete: null,
  onConfirm: null,
  isLoading: false,

  openDeleteModal: (inference, onConfirm) => {
    set({
      isOpen: true,
      inferenceToDelete: inference,
      onConfirm,
    });
  },

  closeDeleteModal: () => {
    set({
      isOpen: false,
      inferenceToDelete: null,
      onConfirm: null,
      isLoading: false,
    });
  },

  confirmDelete: async () => {
    const { onConfirm, closeDeleteModal } = get();
    if (onConfirm) {
      try {
        await onConfirm();
        closeDeleteModal(); // Close modal only on success
      } catch (error) {
        // Modal stays open on error so user can retry
        logger.general.error('Delete operation failed', { error });
      }
    }
  },

  setLoading: (loading) => {
    set({ isLoading: loading });
  },
}));
